"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaFull = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var NFTDataContext_1 = require("../context/NFTDataContext");

var MediaObject_1 = require("../components/MediaObject");

var useMediaContext_1 = require("../context/useMediaContext");

var getContentDataOptions_1 = require("../utils/getContentDataOptions");

var MediaFull = function MediaFull(_ref) {
  var a11yIdPrefix = _ref.a11yIdPrefix,
      _ref$getContentData = _ref.getContentData,
      getContentData = _ref$getContentData === void 0 ? getContentDataOptions_1.defaultGetContentData : _ref$getContentData,
      className = _ref.className;

  var _useMediaContext_1$us = useMediaContext_1.useMediaContext(),
      getStyles = _useMediaContext_1$us.getStyles;

  var _react_1$useContext = react_1.useContext(NFTDataContext_1.NFTDataContext),
      data = _react_1$useContext.nft.data,
      _react_1$useContext$m = _react_1$useContext.metadata,
      metadata = _react_1$useContext$m.metadata,
      error = _react_1$useContext$m.error;

  var getContent = function getContent() {
    if (metadata && data) {
      return jsx_runtime_1.jsx(MediaObject_1.MediaObject, Object.assign({
        isFullPage: true,
        a11yIdPrefix: a11yIdPrefix
      }, getContentData(data, metadata)), void 0);
    }

    if (error) {
      return jsx_runtime_1.jsx("div", Object.assign({}, getStyles("mediaLoader"), {
        children: "error fetching..."
      }), void 0);
    }

    return jsx_runtime_1.jsx("div", Object.assign({}, getStyles("mediaLoader"), {
      children: "loading..."
    }), void 0);
  };

  var media = getContent();
  return jsx_runtime_1.jsx("div", Object.assign({}, getStyles("fullMediaWrapper", className), {
    children: media
  }), void 0);
};

exports.MediaFull = MediaFull;